"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeoutPromise = exports.delay = void 0;
var delay = function (time) {
    // eslint-disable-next-line @typescript-eslint/ban-types
    return new Promise(function (fulfill) {
        setTimeout(fulfill, time);
    });
};
exports.delay = delay;
var timeoutPromise = function (p, timeOutInMs, message) {
    if (message === void 0) { message = 'Timed out'; }
    var timer;
    var expiring = new Promise(function (resolve, reject) {
        timer = setTimeout(function () {
            reject(new Error(message));
        }, timeOutInMs);
    });
    return Promise.race([p, expiring]).finally(function () {
        clearTimeout(timer);
    });
};
exports.timeoutPromise = timeoutPromise;
//# sourceMappingURL=timeout-promise.js.map